import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const PurchaseSuccessIcon = props => {
  return (
    <Svg
      width={27}
      height={30}
      viewBox="0 0 27 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.95 5.241a4.832 4.832 0 018.55-3.088 4.832 4.832 0 017.79 5.69h1.132a4.089 4.089 0 014.089 4.089v2.974a2.603 2.603 0 01-1.906 2.507c.215 2.716.09 5.45-.37 8.138a3.656 3.656 0 01-3.198 3.016l-1.36.152c-4.105.46-8.248.46-12.354 0l-1.36-.152a3.656 3.656 0 01-3.197-3.016 32.878 32.878 0 01-.37-8.138A2.603 2.603 0 01.49 14.906v-2.974a4.089 4.089 0 014.09-4.089h1.13a4.81 4.81 0 01-.76-2.602zm7.435 0a2.602 2.602 0 10-5.204 0 2.602 2.602 0 005.204 0zm4.833 2.602a2.602 2.602 0 100-5.204 2.602 2.602 0 000 5.204zM2.72 11.932c0-1.027.832-1.859 1.858-1.859h7.806v5.204H3.092a.372.372 0 01-.371-.371v-2.974zm11.895 5.576h7.76a30.648 30.648 0 01-.34 7.667 1.426 1.426 0 01-1.246 1.176l-1.36.152c-1.6.179-3.207.285-4.814.319v-9.314zm0-2.23h9.293a.372.372 0 00.371-.372v-2.974a1.859 1.859 0 00-1.858-1.859h-7.806v5.204zm-2.23 2.23v9.314a53.376 53.376 0 01-4.815-.32l-1.36-.151a1.426 1.426 0 01-1.247-1.176 30.647 30.647 0 01-.339-7.667h7.76z"
        fill="#fff"
      />
    </Svg>
  );
};

export default PurchaseSuccessIcon;
